import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ProductType } from "@obg/ngx.core";
import { ConfigService } from "@obg/ngx.global";
import { Observable } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class HeaderConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	isHeaderLanguageSelectorVisible$(): Observable<boolean | undefined> {
		return this.configService.get$((config) => config.coreUi.header.languageSelectorVisible, true);
	}

	isTicketCounterEnabled(): boolean {
		return this.configService.get((config) => config.coreUi.header.isTicketCounterEnabled, false);
	}

	isSponsorshipIconListVisible(): boolean {
		return this.configService.get((config) => config.coreUi.header.sponsorshipIconListVisible, true);
	}

	isLoginEnabled(): boolean {
		return this.configService.get((config) => config.coreUi.header.loginEnabled, false);
	}

	isSportsbookSitemapEnabled(): boolean {
		return this.configService.get((config) => config.coreUi.header.sportsbookSitemapEnabled, false);
	}

	getCustomBrandLogoByProductType(): Partial<Record<ProductType, string>> {
		return this.configService.get((config) => config.coreUi.header.customBrandLogoByProductType, {});
	}
}
